import { render, staticRenderFns } from "./SpecialistNavigation.vue?vue&type=template&id=aa7ef5f4"
import script from "./SpecialistNavigation.vue?vue&type=script&lang=js"
export * from "./SpecialistNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports